import { z } from "zod";

export const resultSchema = z.object({
  categories: z.array(
    z.object({
      id: z.number(),
      content: z.string(),
      points: z.number(),
      subCategories: z.array(
        z.object({
          id: z.number(),
          content: z.string(),
          points: z.number(),
        })
      )
    }),
  ),
  total: z.number(),
});

export type Result = z.infer<typeof resultSchema>;
